/**
 * @description Represents an import conflict where imported data does not match the system data.
 * @author Timothy Biörck
 */

import { ValidatorFn } from "@angular/forms";

export class ImportConflict {
  title: string;
  fileOption: string;
  systemOption: string;
  propertyName: string;
  resolution: string;
  validators: Array<ValidatorFn> = [];

  /**
   * Creates a ImportConflict object.
   * @param title Title of the conflict, i.e what the conflict is about.
   * @param fileOption The value received from a file.
   * @param systemOption The value received from the system.
   * @param propertyName The name of the property that has the conflict (e.g person.firstName has the property name 'firstName')
   */
  constructor(title: string, fileOption: string, systemOption: string, propertyName: string) {
    this.title = title;
    this.fileOption = fileOption ? fileOption : '';
    this.systemOption = systemOption ? systemOption : '';
    this.propertyName = propertyName;
  }

  /**
   * Sets a list of validators to the import conflict.
   * @param validators An array of validators.
   */
  setValidators(validators: Array<ValidatorFn>): void {
    this.validators = validators;
  }
}
